import React, { useState, useEffect, useRef,useContext ,useReducer} from "react";
import { CloseIcon } from "../../assets/svg/CloseIcon";
import styled from "styled-components";
import { TitleText, LabelText, BorderedLabelText } from "../../ui/Text";
import { Formik, Field, FieldArray } from "formik";
import Input,{NumberInput} from "../../ui/Input";
import { DropDown } from "../../ui/DropDown";
import DateRange from "../../ui/DateRange";
import { AttendeeCard } from "../../components/AttendeeCard";
import { CloseIcon2 } from "../../assets/svg/CloseIcon2";
import { Button } from "../../ui/Button";
import { SideSliderContainer } from "../../ui/SideSliderContainer";
import Modal from "../../ui/Modal";
import { AuthContext } from "../../context/AuthContext";
import SearchInput from "../../ui/SearchInput";
import { useLocation } from "react-router-dom";
import { get } from "../../utils/get";
import { GetHook, postEndpoint, putEndpoint, DeleteHook } from "../../api/api";
import { parseDropdown,parseGroupform } from "../../utils/parseDropdown";
import {
  OBJECTIVE_URL,
  USER_URL,
  INITIATIVES_URL,
  TASKS_URL,
  GROUPS_URL
} from "../../api/urls";
import moment from "moment";
import { toast } from "react-toastify";
import DatePicker from "react-datepicker";
import { ReloadPlanSubject } from "../../subjects/ReloadPlanSubject";
import { PlanSchema } from "../../utils/validationSchema/PlanSchema";
import DateRangePicker2 from "../../ui/DateRangePicker";
import { DateTimePicker } from "../../ui/DateTimePicker";
import { TimelineTaskInfoSubject } from "../../subjects/TimelineTaskInfoSubject";
import { GroupIcon } from "../../assets/svg/GroupIcon";
import { UserIcon } from "../../assets/svg/UserIcon";
interface IProps {
  onClick: () => void;
  isOpen?: boolean;
  isEdit?: boolean;
  editData?: any;
  reloadData?: any;
  user?: any;
}

interface InitialValuesProps {
  period: { startDate?: string; endDate?: string }[];
  attendees: any[];
  grouped: [];
  name: string;
  budget: number | string;
  notes: string;
  length: string | number;
  date: any;
  objective: {
    value?: string | number;
    label?: string;
  };
  length_type: {
    value?: string | number;
    label?: string;
  };
  currency: {
    value?: string | number;
    label?: string;
  };
  status: {
    value?: string | number;
    label?: string;
  };
  priority: {
    value?: string | number;
    label?: string;
  };
  timeOptions: {
    value?: string | number;
    label?: string;
  };
  days?: string[];
  startTime?: string;
  endTime?: string;
}

export const AddInitiative = ({
  onClick,
  isOpen,
  isEdit,
  editData,
  reloadData,
  // user,
}: IProps) => {
  const useOutsideAlerter = (ref, ownerRef) => {
    useEffect(() => {
      function handleClickOutside(event) {
        if (ref.current && !ref.current.contains(event.target)) {
          if (!ownerRef.current) {
            onClick();
          }
        }
      }
      document.addEventListener("mousedown", handleClickOutside, true);
      return () => {
        document.removeEventListener("mousedown", handleClickOutside, true);
      };
    }, [ref, ownerRef]);
  };
  const [postRes, postInitiatives] = postEndpoint();
  const [putRes, putInitiatives] = putEndpoint();
  const [deleteURL, setDeleteURL] = useState("null");
  const [selectedDays, setSelectedDays] = useState<Date[]>([]);
  const [filteredUsers, setFilteredUsers] = useState([]);
  const [ownersError, setOwnersError] = useState("");
  const { data: groups } = GetHook(`${GROUPS_URL}?limit=1000`);
  // const options = parseGroupform(groups);
  const SliderRef = useRef(null);
  const ownerRef = useRef(null);
  useOutsideAlerter(SliderRef, ownerRef);
  const {
    data: deleteRes,
    error: deleteError,
    pending: deletePending,
  } = DeleteHook(deleteURL);
  const [openAttendees, setOpenAttendees] = useState(false);
  const auth = useContext(AuthContext);
  const location = useLocation();
  const addAttendees = () => {
    setOpenAttendees(!openAttendees);
  };
  const { user } = get(auth, "authState");
  const isInitiative = get(location, "pathname").includes("initiatives");
  const { data } = GetHook(`${OBJECTIVE_URL}`);
  const { data: initiatives, reload } = GetHook(`${INITIATIVES_URL}`);
  const { data: users } = GetHook(`${USER_URL}?limit=1000`);
  const objectiveOptions = (isInitiative ? data : initiatives).map(
    (objective) => {
      return { value: get(objective, "id"), label: get(objective, "name") };
    }
  );
  const formikRef = useRef<any>(null);
  const groupsOptions = groups.map(
    (group) => {
      return { value: get(group, "id"), label: get(group, "name"),users: get(group, "users") };
    }
  );
  const [selectedGroups, setSelectedGroups] = useState([]);

const selectedGroupMembers = selectedGroups?.map((grp) => {
  return get(grp, "users")

});
const mergedMembers = [].concat.apply([], selectedGroupMembers).filter(
  //@ts-ignore
  (v, i, a) => a.findIndex(t => t.id === v.id) === i
);
  
  
  const statusOptions = [
    {
      label: "Active",
      value: "active",
    },
    { label: "Complete", value: "complete" },
    { label: "In progress", value: "progress" },
  ];
  const priorityOptions = [
    {
      label: "High",
      value: "high",
    },
    { label: "Medium", value: "medium" },
    { label: "Low", value: "low" },
  ];

  const timeOptions = [
    { label: "Every weekday", value: "daily" },
    { label: "Weekly", value: "weekly" },
    { label: "Custom", value: "custom" },
  ];

  const lengthType = isInitiative
    ? [
        { label: "Days", value: "days" },
        { label: "Months", value: "months" },
        { label: "Years", value: "years" },
      ]
    : [
        { label: "Hours", value: "hours" },
        { label: "Days", value: "days" },
        { label: "Months", value: "months" },
        { label: "Years", value: "years" },
      ];

  useEffect(() => {
    if (isOpen) {
      // @ts-ignore
      SliderRef.current?.focus();
    }
    return () => {};
  }, [isOpen]);

  useEffect(() => {
    if (putRes.data && !putRes.pending && !putRes.error) {
      toast.success("Updated successfully!");
      if (!isInitiative) {
        TimelineTaskInfoSubject.next(putRes?.data.returned_resultset[0]);
      }
      onClick();
      return ReloadPlanSubject.next(true);
    } else if (!putRes.pending && putRes.error) {
      toast.error(`Updated failed! ${get(putRes, "data.message", "")}`);
    }
    return () => {};
  }, [putRes]);

  useEffect(() => {
    if (postRes.data && !postRes.pending && !postRes.error) {
      toast.success("Added successfully!");
      onClick();
      return ReloadPlanSubject.next(true);
    } else if (!postRes.pending && postRes.error) {
      toast.error(`Added failed! ${get(postRes, "data.message", "")}`);
    }
    return () => {};
  }, [postRes, location, reload]);
  
  useEffect(() => {
    if (deleteRes && !deleteError && !deletePending) {
      toast.success("Deleted successfully!");
      return ReloadPlanSubject.next(true);
    } else if (deleteRes && deleteError && !deletePending) {
      toast.error(`Delete failed: ${get(deleteError, "data.message")}`);
    }
    return () => {};
  }, [deleteRes, deleteError, deletePending]);

  const handleSubmit = (values: InitialValuesProps) => {
    const owners = values?.attendees.map((attendee) => get(attendee, "id"));
    if (owners.length <= 0) {
      setOwnersError("Please select at least one owner");
      return;
    }
    const period = values?.period.map((per) => {
      return {
        start_date: moment(per.startDate).format("YYYY-MM-DD"),
        end_date: moment(per.endDate).format("YYYY-MM-DD"),
      };
    });
    if (isInitiative) {
      const payload: any = {
        name: values?.name,
        budget: values?.budget,
        objective_id: values?.objective?.value,
        periods: period,
        priority: values?.priority?.value,
        owners: owners,
        created_by: user?.id,
        notes: values?.notes,
        status: values?.status?.value,
      };
      const editpayload: any = {
        name: values?.name,
        budget: values?.budget,
        objective_id: values?.objective?.value,
        periods: period,
        priority: values?.priority?.value,
        owners: owners,
        // created_by: user?.id,
        notes: values?.notes,
        status: values?.status?.value,
      };
      if (get(values, "length")) {
        payload.length = values?.length;
        payload.length_type = values?.length_type?.value;
        editpayload.length = values?.length;
        editpayload.length_type = values?.length_type?.value;
      }
      if (get(values, "budget")) {
        payload.budget = values?.budget;
        editpayload.budget = values?.budget;
        //  payload.budget_type = values?.budget_type?.value;
      }
      isEdit
        ? putInitiatives(
            `${INITIATIVES_URL}/${get(editData, "[0].id")}`,
            editpayload
          )
        : postInitiatives(INITIATIVES_URL, payload);
    } else {
      const payload: any = {
        name: values?.name,
        notes: values?.notes,
        initiative_id: values?.objective?.value,
        due_date: get(values, "date"),
        owners: owners,
        status: values?.status?.value,
        priority: values?.priority?.value,
        created_by: user?.id,
        periods: get(
          initiatives.filter(
            (initiative) => get(initiative, "id") === values?.objective?.value
          ),
          "periods"
        ),
      };
      const editpayload: any = {
        name: values?.name,
        notes: values?.notes,
        initiative_id: values?.objective?.value,
        due_date: get(values, "date"),
        owners: owners,
        status: values?.status?.value,
        priority: values?.priority?.value,
        // created_by: user?.id,
        periods: get(
          initiatives.filter(
            (initiative) => get(initiative, "id") === values?.objective?.value
          ),
          "periods"
        ),
      };
      
      if (get(values, "length")) {
        payload.length = values?.length;
        payload.length_type = values?.length_type?.value;
      }
      if (get(values, "budget")) {
        //@ts-ignore
        payload.budget = parseFloat(values?.budget.replace(/,/g, ""));
        // parseFloat(get(values, i).replace(/,/g, ""))
        //  payload.budget_type = values?.budget_type?.value;
      }

      isEdit
        ? putInitiatives(`${TASKS_URL}/${get(editData, "[0].id")}`, editpayload)
        : postInitiatives(TASKS_URL, payload);
    }
  };

  const initialValues: InitialValuesProps =
    isOpen && isEdit
      ? {
          period: get(editData, "[0].periods", []).map((period) => {
            return {
              startDate: new Date(get(period, "start_date")),
              endDate: new Date(get(period, "end_date")),
            };
          }),
          attendees: get(editData, "[0].owners", []).map((attendee) => {
            return {
              id: get(attendee, "owner_id", ""),
              names: get(attendee, "owner_names", ""),
            };
          }),
          grouped: get(editData, "[0].groups", []).map((group) => {
            return {
              id: get(group, "group_id", ""),
              names: get(group, "group_names", ""),
            };
          }),
          name: get(editData, "[0].name", ""),
          notes: get(editData, "[0].notes", ""),
          budget: get(editData, "[0].budget", ""),
          date: new Date(get(editData, "[0].due_date")),
          objective: get(
            objectiveOptions.filter(
              (obj) =>
                obj.value ===
                get(
                  editData,
                  "[0].objective_id",
                  get(editData, "[0].initiative_id")
                )
            ),
            "[0]"
          ),
          length: get(editData, "[0].length", ""),
          length_type: get(
            lengthType.filter(
              (type) => type.value === get(editData, "[0].length_type")
            ),
            "[0]",
            null
          ),
          currency: { label: "KSH", value: "KSH" },
          status: get(
            statusOptions.filter(
              (status) => status.value === get(editData, "[0].status")
            ),
            "[0]",
            null
          ),
          priority: get(
            priorityOptions.filter(
              (priority) => priority.value === get(editData, "[0].priority")
            ),
            "[0]",
            null
          ),
          timeOptions: get(
            timeOptions.filter(
              (option) =>
                option.value === get(editData, "[0].task_times[0].options")
            ),
            "[0]",
            null
          ),
          days:
            get(editData, "[0]task_times[0]options") === "weekly" &&
            get(editData, "[0]task_times[0]option_values")
              .replace("[", "")
              .replace("]", "")
              .split(",")
              .map((item) =>
                item.replace("'", "").replace(" ", "").replace("'", "")
              ),
          startTime: get(editData, "[0]task_times[0].start_time"),
          endTime: get(editData, "[0]task_times[0].end_time"),
        }
      : {
          period: [
            {
              startDate: "",
              endDate: "",
            },
          ],
          attendees: [],
          grouped:[],
          name: "",
          budget: "",
          notes: "",
          length_type: lengthType[0],
          currency: { label: "KSH", value: "KSH" },
          date: new Date(),
          objective: {},
          length: "",
          status: {},
          priority: {},
          timeOptions: {},
          days: [],
        };

  const handleSelectedDays = (day: Date) => {
    const selected = selectedDays.filter(
      (selectedDay) =>
        moment(selectedDay).format("YYYY-MM-DD") ===
        moment(day).format("YYYY-MM-DD")
    );

    if (selected.length > 0) {
      const newSelectedDays = selectedDays.filter(
        (selectedDay) =>
          moment(selectedDay).format("YYYY-MM-DD") !==
          moment(day).format("YYYY-MM-DD")
      );
      setSelectedDays(newSelectedDays);
    } else {
      setSelectedDays([...selectedDays, day]);
    }
  };
  const handleAttendeeSearch = (e) => {
    const filtered = users.filter((user) =>
      user.names.toLowerCase().includes(e.target.value.toLowerCase())
    );
    setFilteredUsers(filtered);
  };
  

  useEffect(() => {
    if(formikRef.current && mergedMembers.length){
      formikRef.current.setFieldValue("attendees",mergedMembers)
    }
  }, [mergedMembers]);

  
  return (
    <Formik<InitialValuesProps>
      enableReinitialize={false}
      initialValues={initialValues}
      onSubmit={handleSubmit}
      validationSchema={PlanSchema}
      validateOnBlur
      validateOnChange
      //@ts-ignore
      innerRef={formikRef}
    >
      {({ handleSubmit, values, setFieldValue, resetForm }) => (
        <>
          <AddTaskContainer>
            <AddTaskHeader>
              <TitleText style={{ overflowX: "hidden" }}>
                {isEdit ? "Edit " : "Add new "}
                {isInitiative ? "Initiative" : "Task"}
              </TitleText>
              <CloseIcon
                onClick={() => {
                  resetForm({
                    // @ts-ignore
                    period: [{ startDate: "", endDate: "" }],
                    attendees: [],
                    name: "",
                    budget: 0,
                    notes: "",
                    objective: { label: "", value: "" },
                    length: "",
                    status: { label: "", value: "" },
                    priority: { label: "", value: "" },
                  });
                  onClick();
                }}
              />
            </AddTaskHeader>
            <Field
              name="name"
              component={Input}
              label={isInitiative ? "Initiative Name" : "Task name"}
            />
            <Field
              type="textarea"
              name="notes"
              component={Input}
              height="6em"
              label={
                isInitiative ? "Initiative Description" : "Task Description"
              }
            />
            <Field
              name="priority"
              options={priorityOptions}
              component={DropDown}
              dropdownLabel={`${isInitiative ? "Initiative" : "Task"} Priority`}
              label="Priority"
              width="97%"
              backgroundColor="#F5F6FB"
            />

            <Field
              name="objective"
              width="97%"
              component={DropDown}
              dropdownLabel={isInitiative ? "Objective" : "Initiative"}
              backgroundColor="#F5F6FB"
              options={objectiveOptions}
              onChange={(value) => {
                setFieldValue("objective", value);
              }}
            />
            {isInitiative ? (
              <>
                <AddItemHeader>
                  <LabelText>Date</LabelText>
                  <TitleText
                    onClick={() =>
                      setFieldValue("period", [...values.period, {}])
                    }
                  >
                    Add date<label style={{ color: "#01A8CE" }}> +</label>
                  </TitleText>
                </AddItemHeader>
                <div>
                  <FieldArray
                    name="period"
                    render={(arrayHelpers) => (
                      <div>
                        {values.period &&
                          values.period.length > 0 &&
                          values.period.map((date, index) => (
                            <DateContainer key={index}>
                              <div>
                                <BorderedLabelText>
                                  {index + 1}
                                </BorderedLabelText>
                              </div>
                              <Field
                                name={`period.[${index}]`}
                                label=""
                                component={DateRange}
                              />
                              <CloseIcon2
                                onClick={() => arrayHelpers.remove(index)}
                              />
                            </DateContainer>
                          ))}
                      </div>
                    )}
                  />
                </div>
              </>
            ) : (
              <>
                <Field
                  name="date"
                  component={DateTimePicker}
                  label="Due Date"
                />
              </>
            )}
            <SelectInputContainer>
              <LabelText>Budget</LabelText>
              <div />
              <Field
                name="currency"
                component={DropDown}
                width="100%"
                options={[{ label: "KSH", value: "KSH" }]}
                backgroundColor="#F5F6FB"
                isClearable={false}
              />
              <Field
                name="budget"
                component={NumberInput}
                height="0.7em"
                width="100%"
                backgroundColor="#fff"
              />
            </SelectInputContainer>

            <SelectInputContainer>
              <LabelText>Length</LabelText>
              <div />
              <Field
                name="length_type"
                component={DropDown}
                width="100%"
                options={lengthType}
                isClearable={false}
                backgroundColor="#F5F6FB"
              />
              <Field
                name="length"
                component={Input}
                width="100%"
                height="0.7em"
                backgroundColor="#fff"
              />
            </SelectInputContainer>
            <AttendeesContainer>
              <AddItemHeader>
                <LabelText>Owners</LabelText>
                <TitleText onClick={() => addAttendees()}>
                  Add Owners <label style={{ color: "#01A8CE" }}>+</label>
                </TitleText>
              </AddItemHeader>
              <Field
              name="groupings"
              component={DropDown}
              dropdownLabel="Select a Group"
              options={groupsOptions}
              onChange={(value) => {
                setSelectedGroups(value);
              }}
              // value={selectedGroups}
              isMulti
              isClearable
              label="groups"
              width="97%"
              backgroundColor="#F5F6FB"
            />
              {values.attendees &&
                values.attendees.length > 0 &&
                values.attendees.map((attendee, index) => (
                  <AttendeeCard
                    key={attendee.id}
                    isClosable={true}
                    data={attendee}
                    setSelected={(isTrue) => {
                      return (
                        !isTrue &&
                        setFieldValue(
                          "attendees",
                          values.attendees.filter((atte) => atte !== attendee)
                        )
                      );
                    }}
                  />
                ))}
              <ErrorText>{ownersError}</ErrorText>
            </AttendeesContainer>
            <ButtonContainer>
              <TitleText
                onClick={() => {
                  resetForm();
                  onClick();
                }}
              >
                Cancel
              </TitleText>
              {/* {isEdit && (
                <Button
                  style={{ marginLeft: 5 }}
                  backgroundColor="#FF6666"
                  text={"Delete"}
                  onClick={() =>
                    setDeleteURL(
                      `${isInitiative ? INITIATIVES_URL : TASKS_URL}/${get(
                        editData,
                        "[0].id"
                      )}`
                    )
                  }
                />
              )} */}
              <Button
                style={{ marginLeft: 5 }}
                text={isEdit ? "Update" : "Create"}
                onClick={() => handleSubmit()}
              />
            </ButtonContainer>
          </AddTaskContainer>

          {openAttendees && (
            <Modal
            // @ts-ignore
            modalRef={ownerRef}
            title="Add attendees"
            closeModal={() => {
              setFieldValue("attendees", []);
              setOpenAttendees(false);
            }}
            handleSubmit={() => setOpenAttendees(false)}
          >
            {/* <Field
              name="groupings"
              component={DropDown}
              dropdownLabel="Select a Group"
              options={groupsOptions}
              onChange={(value) => {
                setSelectedGroups(value);
              }}
              value={selectedGroups}
              isMulti
              isClearable
              label="groups"
              width="97%"
              backgroundColor="#F5F6FB"
            /> */}
            <SearchInput handleChange={handleAttendeeSearch} />
            <FieldArray
              name="attendees"
              render={({ remove, push }) => (
                <div style={{ height: "70vh", overflow: "auto" }}>
                  {(filteredUsers.length ? filteredUsers : users).map(
                    (user, index) => 
                      {
                        
                      return(
                      <AttendeeCard
                      //@ts-ignore
                        isPreSelected={
                          values.attendees.find(
                          (attendee) => user.id === attendee.id,
                        )}
                        key={user.id}
                        data={user}
                        setSelected={(isTrue) => {
                          return !isTrue ? remove(user) : push(user);
                        }}
                      />)}
                    
                  )}
                </div>
              )}
            />
          </Modal>
          )}
        </>
      )}
    </Formik>
  );
};

const AddTaskContainer = styled.div`
  display: grid;
  grid-template-rows: repeat(11, auto);
  grid-row-gap: 1em;
`;

const AddTaskHeader = styled.div`
  display: grid;
  grid-template-columns: auto 2em;
  align-items: center;
  overflow-x: hidden;
`;

const SelectInputContainer = styled.div`
  display: grid;
  align-items: center;
  grid-template-columns: 1fr 2fr;
  grid-template-rows: auto 4.4em;
  grid-column-gap: 1em;
  padding-right: 1.5em;
`;

const AttendeesContainer = styled.div`
  display: grid;
  grid-template-rows: repeat(auto, 1em);
  grid-row-gap: 0.5em;
  padding-right: 0.5em;
`;

const AddItemHeader = styled.div`
  display: grid;
  grid-template-columns: 3fr 2fr;
  justify-content: space-between;
  ${TitleText} {
    text-align: end;
  }
`;

const DateContainer = styled.div`
  display: grid;
  align-items: center;
  grid-template-columns: 4em auto 1em;
  margin-bottom: 0.5em;
  width: 100%;
`;

const ButtonContainer = styled.div`
  display: flex;
  align-items: center;
  justify-self: flex-end;
`;

const PriorityStatus = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  grid-column-gap: 3em;
`;
const TimeSection = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr 1.5fr;
  grid-column-gap: 3em;
`;
const SelectDaysSection = styled.div`
  justify-items: flex-start;
  justify-self: flex-end;
  display: grid;
  grid-template-columns: 1em 5em;
  grid-template-rows: repeat(5, 1fr);
  grid-column-gap: 1em;
  grid-row-gap: 0.5em;
  padding: 0.5em 3em 0.5em 1em;
  border: 1px solid #d9dfff;
  border-radius: 5px;
  /* ${TitleText} {
    text-justify: 
  } */
`;

const InlineDateContainer = styled.div`
  display: flex;
  align-self: flex-end;
  justify-content: flex-end;
`;

const ErrorText = styled.span`
  padding: 0;
  margin: 0;
  color: red;
  font-size: 12px;
`;

const WizzardHeader = styled.div`
  display: flex;
  flex-direction: row;
  /* justify-content: space-between; */
  align-items: center;
  border: 2px solid rgba(76, 92, 251, 0.1);
  border-radius: 1em;
  margin-top: 1em;
  margin-bottom: 1em;
`;
const HeaderItem = styled.button<{ enabled: boolean }>`
  display: flex;
  font-size: 12;
  font-weight: 600;
  align-items: center;
  background-color: ${(props) => (props.enabled ? "#EBEFFF" : "#fff")};
  color: #01A8CE;
  padding: 1em 1.5em 1em 1.5em;
  border-radius: 1em;
  width: 100%;
  box-shadow: 0px 0px 0px transparent;
  border: 0px solid transparent;
  text-shadow: 0px 0px 0px transparent;
  opacity: ${(props) => (props.enabled ? 1 : 0.4)};
  ${TitleText} {
    padding-left: 1em;
    color: #01A8CE;
    font-size: 12px;
  }
  &:focus {
    outline: none;
  }
`;

const ButtonWithBorder = styled(Button)<{ disabled: boolean }>`
  border: 2px solid #01A8CE;
  padding: 0.3em 4em;
  margin-left: auto;
  margin-right: 1em;
  opacity: ${(props) => (props.disabled ? 0.4 : 1)};
`;

const SmallButton = styled(Button)`
  padding: 0.4em 4em;
  border: 2px solid #01A8CE;
`;

const Footer = styled.footer`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-top: 1em;
`;